export default __webpack_public_path__ + "static/media/handspeople.0ff10c1f.png";